export const breadcrumbsReducerKey = 'Breadcrumbs';
export const breadcrumbsRetrievedType = 'BREADCRUMBS_RETRIEVED_TYPE';
export const BACK_TO_QUERY_QUICK_SEARCH_ACTIONS = {
  PREVIEW: 'preview',
  EDIT: 'edit',
};
